const cartBanner = {
	constants: {
		ONE_WEEK_MS: 7 * 24 * 60 * 60 * 1000
	},

	init() {
		if (this.isActiveCartAbandoned()) {
			this.showCartIconOnHeader();
			/**
			 * Note: We are experimenting by removing the upsell banner to see impact on conversion rate.
			 */
			// this.showHomeDiscountBanner();
			// this.showPricingPageBanner();
		}
	},

	isFreePlanSelected() {
		const storedData = this.getStoredPlanDetails();
		return (storedData?.planName || "").toLowerCase() === 'free';
	},

	isMonthlyPlanSelected() {
		const storedData = this.getStoredPlanDetails();
		return (storedData?.planDetails?.plan_mode || "").toLowerCase() === 'month';
	},

	getStoredPlanDetails() {
		try {
			const storedData = localStorage.getItem('pe_signup_plan_details');
			if (!storedData) {
				return null;
			}
			const parsedData = JSON.parse(storedData);
			if (Date.now() - parsedData?.timestamp >= this.constants.ONE_WEEK_MS) {
				localStorage.removeItem('pe_signup_plan_details');
				return null;
			}
			return parsedData;
		} catch (e) {
			console.error('Error while parsing stored plan details', e);
			return null;
		}
	},

	getSignupPlanURL() {
		const storedData = this.getStoredPlanDetails();
		if (!storedData) return '/pricing';
	
		const params = new URLSearchParams();
	
		if (storedData.plan) params.append('plan', storedData.plan);
		if (storedData.planName) params.append('planName', storedData.planName);
		if (storedData.coupon) params.append('coupon', storedData.coupon);
	
		return `/signup?${params.toString()}`;
	},

	isActiveCartAbandoned() {
		const storedData = this.getStoredPlanDetails();
		return storedData && Date.now() - storedData.timestamp < this.constants.ONE_WEEK_MS;
	},

	showCartIconOnHeader() {
		const cartIcon = document.createElement('li');
		cartIcon.classList.add('pe-header-cart-btn');
		cartIcon.innerHTML = `
			<a href="${this.getSignupPlanURL()}" class="pe-header-cart-icon">
				<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M5.97439 18.442C5.56067 18.442 5.20797 18.2947 4.9163 18.0001C4.62464 17.7055 4.4788 17.3513 4.4788 16.9376C4.4788 16.5239 4.62611 16.1712 4.92072 15.8795C5.21535 15.5879 5.56951 15.442 5.98322 15.442C6.39694 15.442 6.74964 15.5893 7.04131 15.8839C7.33297 16.1786 7.47881 16.5327 7.47881 16.9464C7.47881 17.3602 7.3315 17.7129 7.03689 18.0045C6.74226 18.2962 6.3881 18.442 5.97439 18.442ZM14.3077 18.442C13.894 18.442 13.5413 18.2947 13.2496 18.0001C12.958 17.7055 12.8121 17.3513 12.8121 16.9376C12.8121 16.5239 12.9594 16.1712 13.2541 15.8795C13.5487 15.5879 13.9028 15.442 14.3166 15.442C14.7303 15.442 15.083 15.5893 15.3746 15.8839C15.6663 16.1786 15.8121 16.5327 15.8121 16.9464C15.8121 17.3602 15.6648 17.7129 15.3702 18.0045C15.0756 18.2962 14.7214 18.442 14.3077 18.442ZM5.11922 4.69203L7.21068 9.04163H13.1754L15.544 4.69203H5.11922ZM4.35291 3.18294H16.2838C16.7064 3.18294 17.028 3.37196 17.2486 3.74998C17.4691 4.12801 17.4725 4.50996 17.2587 4.89584L14.6464 9.61684C14.4779 9.89642 14.2641 10.1239 14.0049 10.2994C13.7457 10.4748 13.4545 10.5625 13.1312 10.5625H6.90272L5.81849 12.5996H15.9417V14.1087H5.77047C5.12433 14.1087 4.66101 13.8907 4.38051 13.4547C4.10003 13.0187 4.10743 12.538 4.40272 12.0127L5.70072 9.62499L2.6047 3.04619H0.932617V1.53711H3.58208L4.35291 3.18294Z" fill="#141B38"></path>
				</svg>
			</a>
			<a class="pe-cart-bubble animate" href="${this.getSignupPlanURL()}">1</a>
		`;

		document.querySelector('.pe-header-geting-started-btn')?.insertAdjacentElement('afterend', cartIcon);
	},

	getCTAButtonLabel(page = 'home') {
		const storedData = this.getStoredPlanDetails();
		if (!storedData?.planName) return PEUpsellBannerData?.ctaLabels?.home?.premium;

		const { discountPercentage, couponCode } = PEUpsellBannerData || {};

		if (page === 'pricing') {
			if (this.isFreePlanSelected()) return PEUpsellBannerData?.ctaLabels?.pricing?.free;

			if ( this.isMonthlyPlanSelected() ) return PEUpsellBannerData?.ctaLabels?.pricing?.monthly;

			if (discountPercentage && couponCode) return PEUpsellBannerData?.ctaLabels?.pricing?.premium;
		}

		if (this.isMonthlyPlanSelected() && !this.isFreePlanSelected() ) return PEUpsellBannerData?.ctaLabels?.home?.monthly;

		return page === 'home' && this.isFreePlanSelected() ? PEUpsellBannerData?.ctaLabels?.home?.free : PEUpsellBannerData?.ctaLabels?.home?.premium;
	},

	showHomeDiscountBanner() {
		const isHomePage = window.location.pathname === '/';
		const homePageCTA = document.querySelector('.wp-block-pushengage-theme-action-call');
		if ( !isHomePage || !homePageCTA) return;

		document.body.classList.add('pe-cart-upsell-banner-active');

		let signupURL = this.getSignupPlanURL();

		if ( this.isMonthlyPlanSelected() ) {
			const couponCode = PEUpsellBannerData?.monthlyCouponCode || '';
			if (couponCode && !this.isFreePlanSelected()) {
				signupURL = signupURL.replace(/&coupon=[^&]*/, '') + `&coupon=${couponCode}`;
			}
		}

		const banner = document.createElement('div');
		banner.classList.add('pe-cart-banner', 'is-layout-flex', 'wp-block-group');
		banner.innerHTML = wp.template('pe-upsell-banner-template')({
			signupPlanURL: signupURL,
			btnText: this.getCTAButtonLabel()
		});

		homePageCTA.innerHTML = '';
		document.querySelector('.wp-block-pushengage-theme-features-list')?.insertAdjacentElement('afterend', banner);
	},

	showPricingPageBanner() {
		const pricingPageSelector = document.querySelector('#pe-pricing-start');
		if (!pricingPageSelector) return;

		let signupURL = this.getSignupPlanURL();
		const couponCode = ( this.isMonthlyPlanSelected() ? PEUpsellBannerData?.monthlyCouponCode : PEUpsellBannerData?.couponCode ) || '';
		if (couponCode && !this.isFreePlanSelected()) {
			signupURL = signupURL.replace(/&coupon=[^&]*/, '') + `&coupon=${couponCode}`;
		}

		const banner = document.createElement('div');
		banner.classList.add('pe-cart-banner');
		banner.innerHTML = wp.template('pe-upsell-banner-template')({
			signupPlanURL: signupURL,
			btnText: this.getCTAButtonLabel('pricing')
		});

		pricingPageSelector.insertAdjacentElement('beforeBegin', banner);
	}
};

export default cartBanner;
